import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import Environment from '@env';

const { auth0Config } = Environment;

@Injectable({
  providedIn: 'root'
})
export class Auth0Service {
  auth0ClientConfiguration = {
    domain: auth0Config.domain,
    client_id: auth0Config.client_id,
    redirect_uri: `${window.location.origin}/login`
  };

  // Create subject and public observable of user profile data
  private userProfileSubject$ = new BehaviorSubject<any>(null);
  userProfile$ = this.userProfileSubject$.asObservable();
  // Create a local property for login status
  loggedIn: boolean = null;

  constructor(private router: Router) {}

  login(redirectPath: string = '/', connection?: string, state?: any) {
    const appState = JSON.stringify(state || { target: redirectPath });
    // Our client authorize url implementation
    //  that supports server side /userinfo call
    const targetUrl =
      `https://${this.auth0ClientConfiguration.domain}/authorize?response_type=code&scope=openid profile email` +
      `&client_id=${this.auth0ClientConfiguration.client_id}` +
      `&redirect_uri=${encodeURIComponent(window.location.origin + '/login')}` +
      `&audience=${encodeURIComponent(`https://${this.auth0ClientConfiguration.domain}/userinfo`)}` +
      `&state=${encodeURIComponent(appState)}` +
      `&connection=${encodeURIComponent(connection)}` +
      '&prompt=login';

    window.location.href = targetUrl;
  }

  public getCallBackData(): { code: string; state: string } {
    const params = window.location.search;
    if (params.includes('code=') && params.includes('state=')) {
      const urlParams = new URLSearchParams(params);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      return { code, state };
    }
    return null;
  }
}
